import _get from "lodash/get";
import { connect } from 'react-redux';
import ProgramCard from '../components/program-card/program-card';
export default (function () {
  var reducerPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'fthbPrograms';
  return connect(function (state) {
    return {
      program: _get(state, reducerPath),
      impressions: _get(state, 'impressions')
    };
  })(ProgramCard);
});